import { useEffect, useState } from "react";
import { GET } from "Common/api";
import {
  METADATA_FIELD_TYPE,
  METADATA_ITEM_TYPE_EXTERNAL_COURSE,
} from "lib/components/ItemMetadataFields/itemMetadata.constants";

export const useExternalMetadata = ({
  ready,
  activityId,
  fromEducationHistory,
}) => {
  const [itemMetadataFields, setItemMetadataFields] = useState([]);
  const [itemMetadataValuesById, setItemMetadataValuesById] = useState({});
  const [itemMetadataErrorsById, setItemMetadataErrorsById] = useState({});

  useEffect(() => {
    if (!ready) {
      return;
    }

    let cancelled = false;

    const resetMetadataState = () => {
      setItemMetadataFields([]);
      setItemMetadataValuesById({});
      setItemMetadataErrorsById({});
    };

    const loadMetadata = async () => {
      try {
        const hasStableActivityId =
          activityId !== undefined &&
          activityId !== null &&
          activityId !== true;

        const url = hasStableActivityId
          ? fromEducationHistory
            ? `/v1/coworker/externalcourse/${activityId}/external-metadata`
            : `/v1/coworkeractivity/${activityId}/external-metadata`
          : `/v1/metadata/definitions/${METADATA_ITEM_TYPE_EXTERNAL_COURSE}`;

        const data = await GET(url);
        if (cancelled || !Array.isArray(data) || data.length === 0) {
          if (!cancelled) {
            resetMetadataState();
          }
          return;
        }

        const initialValues = {};
        data.forEach((field) => {
          const hasValue =
            field.value !== undefined &&
            field.value !== null &&
            String(field.value).length > 0;
          const value = hasValue ? String(field.value) : "";

          if (field.fieldType === METADATA_FIELD_TYPE.Bool) {
            initialValues[field.id] =
              value === "1" || value.toLowerCase() === "true" ? "1" : "0";
          } else {
            initialValues[field.id] = value;
          }
        });

        if (!cancelled) {
          setItemMetadataFields(data);
          setItemMetadataValuesById(initialValues);
          setItemMetadataErrorsById({});
        }
      } catch {
        if (!cancelled) {
          resetMetadataState();
        }
      }
    };

    loadMetadata();

    return () => {
      cancelled = true;
    };
  }, [ready, activityId, fromEducationHistory]);

  const handleItemMetadataChange = (id, value) => {
    setItemMetadataValuesById((prev) => ({ ...prev, [id]: value }));
    setItemMetadataErrorsById((prev) => {
      if (!prev[id]) {
        return prev;
      }
      const next = { ...prev };
      delete next[id];
      return next;
    });
  };

  return {
    itemMetadataFields,
    itemMetadataValuesById,
    itemMetadataErrorsById,
    setItemMetadataErrorsById,
    handleItemMetadataChange,
  };
};
